import { useContext, useEffect } from "react";
import { Field } from "react-final-form";
import { useIntl } from "react-intl";
import Section from "../../common/section";
import * as Validations from "../../common/form/validator";
import { TextInput } from "../../common/fields";
import { FormContext } from "../../common/context";

const SMTPForm = ({ disabled, record }) => {
  const intl = useIntl();

  const formProvider = useContext(FormContext);

  useEffect(() => {
    if (disabled) {
      formProvider.change("userName", "");
      formProvider.change("password", "");
      formProvider.resetFieldState("userName");
      formProvider.resetFieldState("password");
    }
  }, [disabled, record]);

  return (
    <Section title="smtp_settings">
      <div className="flex flex-column gap-2">
        <div className="grid">
          <div className="col-12 md:col-6 lg:col-4">
            <Field
              name="server"
              required
              disabled={disabled}
              component={TextInput}
              label={intl.formatMessage({ id: "smtp_host" })}
              validate={Validations.required}
            />
          </div>
          <div className="col-12 md:col-6 lg:col-4">
            <Field
              name="port"
              type="number"
              required
              component={TextInput}
              disabled={disabled}
              label={intl.formatMessage({ id: "smtp_port" })}
              validate={Validations.required}
            />
          </div>
          <div className="col-12 md:col-6 lg:col-4">
            <Field
              name="senderName"
              required
              component={TextInput}
              disabled={disabled}
              label={intl.formatMessage({ id: "sender_name" })}
              validate={Validations.required}
            />
          </div>
          <div className="col-12 md:col-6 lg:col-4">
            <Field
              name="senderEmail"
              type="email"
              required
              component={TextInput}
              disabled={disabled}
              label={intl.formatMessage({ id: "sender_email" })}
              validate={Validations.composeValidators(
                Validations.required,
                Validations.checkEmailFormat
              )}
            />
          </div>
          <div className="col-12 md:col-6 lg:col-4">
            <Field
              name="userName"
              component={TextInput}
              type="password"
              required
              disabled={disabled}
              label={intl.formatMessage({ id: "smtp_username" })}
              validate={Validations.required}
            />
          </div>
          <div className="col-12 md:col-6 lg:col-4">
            <Field
              name="password"
              type="password"
              component={TextInput}
              disabled={disabled}
              required
              label={intl.formatMessage({ id: "smtp_password" })}
              validate={Validations.required}
            />
          </div>
        </div>
      </div>
    </Section>
  );
};

export default SMTPForm;
